module.exports = __webpack_public_path__ + "static/media/vijay-sales-logo.b75efd8c.svg";